import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { listPaymentsToReconcile, confirmReconciliation } from '../api/financeApi';
import useFinanceQuery from '../useFinanceQuery';
import FinanceListPage from '../components/FinanceListPage';
import DetailLinkButton from '../components/DetailLinkButton';
import { useFinance } from '../financeContext';
import { money } from '../format';
import MessageModal from '../components/MessageModal';

export default function PaymentsToReconcilePage() {
  const { canApproveFinance } = useFinance();
  const q = useFinanceQuery(
    (params) => listPaymentsToReconcile(params),
    { filterKeys: ['vertical', 'minAmount', 'maxAmount', 'dateFrom', 'dateTo', 'method'] }
  );
  const [note, setNote] = useState({});
  const [busyId, setBusyId] = useState('');
  const [actionError, setActionError] = useState('');

  const confirm = async (id) => {
    setBusyId(id);
    try {
      await confirmReconciliation(id, note[id] || '');
      await q.reload();
    } catch (err) {
      setActionError(err?.response?.data?.msg || 'Unable to confirm this payment.');
    } finally {
      setBusyId('');
    }
  };

  const columns = [
    { key: 'ref', header: 'Booking', cardHeader: true, cell: (r) => <DetailLinkButton kind="booking" entity={r} /> },
    { key: 'vertical', header: 'Vertical', cell: (r) => r.vertical },
    { key: 'customer', header: 'Customer', cell: (r) => r.customerName },
    { key: 'amount', header: 'Amount', cell: (r) => money(r.paymentSummary?.amountReceived ?? r.payment?.amountReceived ?? 0) },
    { key: 'how', header: 'How', cell: (r) => (r.paymentSummary?.method || r.payment?.method || '—').replace(/_/g, ' ') },
    { key: 'reference', header: 'Reference', cell: (r) => <span className="font-monospace small">{r.paymentSummary?.reference || r.payment?.reference || '—'}</span> }
  ];

  const rowActions = !canApproveFinance ? undefined : (r) => (
    <div style={{ minWidth: 180 }}>
      <Form.Control
        size="sm" className="mb-1" placeholder="Note (optional)"
        value={note[r._id] || ''}
        onChange={(e) => setNote((p) => ({ ...p, [r._id]: e.target.value }))}
      />
      <Button size="sm" variant="success" disabled={busyId === r._id} onClick={() => confirm(r._id)}>Confirm received</Button>
    </div>
  );

  return (
    <>
      <FinanceListPage
        title="Payments to reconcile"
        subtitle="Owner-recorded payments awaiting finance confirmation that the money actually landed."
        q={q}
        columns={columns}
        rowActions={rowActions}
        filterFields={['vertical', 'amount', 'date', 'method']}
        searchPlaceholder="Search booking, customer or reference"
        emptyText="No owner-recorded payments waiting for confirmation."
      />
      <MessageModal
        show={!!actionError}
        onHide={() => setActionError('')}
        title="Could not confirm payment"
        message={actionError}
      />
    </>
  );
}
